// First, so no other module can log before production builds go quiet.
import "./utils/quietConsole";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap";
import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot for React 18
import App from "./App";
// After App so the shared dialog look wins over older global .modal-* rules
import "./styles/modals.css";
import reportWebVitals from "./reportWebVitals";
import { initTerminologyReplacement } from "./terminology";
import { installLegacyIconClasses } from "./components/common/icons";
import { captureInstallPrompt } from "./pwa/installPrompt";
import { registerServiceWorker } from "./pwa/serviceWorker";
import { startPushListeners } from "./pwa/pushNotifications";

// Before React starts: Chrome can offer its install popup as soon as the page loads.
captureInstallPrompt();

// The app's only copy of Bootstrap JS. Components call window.bootstrap.Modal / .Dropdown,
// and every extra copy also handles data-bs-toggle clicks, so with two copies a dropdown
// opens and immediately closes again. Import "bootstrap" here, never the dist bundles.
window.bootstrap = bootstrap;

// Draw any remaining "bi bi-…" / "fa-…" icon classes with ANNA's own glyphs.
installLegacyIconClasses();

// Find the root element
const container = document.getElementById("root");

// Use createRoot instead of ReactDOM.render
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Initialize UI terminology replacement globally (frontend-only)
initTerminologyReplacement();

reportWebVitals();

// Makes ANNA installable as a phone app (production builds only).
registerServiceWorker();
// Tapping a notification while ANNA is open moves it to that page.
startPushListeners();
